

<template>
  <div id="addressPage">
		<div class='addressPageBox'>
		
		  <div id="newaddress" v-if='!add'>
		  	<div class="app-btn app-btn--shadow app-btn--large" @click='handleAddAddress'>新建地址</div>
		  </div>
	  
			<div class='delAddressBox' v-if='delAddressShow'>
				<div class='delAddressBoxTitle'>是否确定删除该地址</div>
				<div class='delAddressBoxBtn'>
					<div @click='closeDel'>取消</div>
					<div @click='delAddress'>确定</div>
				</div>
			</div>
			<div class='delAddressPop' v-if='delAddressShow'></div>
		<div v-if='!add'>
			
			<div v-if='addressList.length>0'>
				<div class="option-btn" @click="toggle" >
					{{ edit ? '完成' : '管理'}}
				</div>
				<div class="addresses"  :class="edit ? 'is-edit' : ''"   v-for='item in addressList' >
					<div class="addressitem" :class="item.is_default==1?'default':''"  @click='hanleChooseAddress(item)'>
						<div class="name-phone">
							<div>收货人：{{item.name}}</div>
							<div>{{item.phone}}</div>
						</div>
						<div class="idcard">身份证号：{{item.id_card}}</div>
						<div class="street">
						<span v-if='item.is_default==1'>[默认地址]</span>
						{{item.province_name + item.city_name + item.area_name + item.address}}
						</div>
						<div class="options">
							<div class="left" @click.stop='handleDefault(item.id)' >
							   <!-- <img src="../assets/icon-checked2.png"  v-if='item.is_default==1' />
								<img src="../assets/icon-check.png" v-else />
								<span>默认地址</span> -->
							</div>
							<div class="right">
								<div  class="btn" @click.stop='handleEdit(item)' >
									<img src="../assets/icon-edit.png" style="width: 0.3rem; height: 0.3rem;" /> 编辑
								</div>
								<div class="btn" @click.stop='handleDel(item.id)' >
									
									<img src="../assets/delete2.png" style="width: 0.25rem; height:0.3rem;" /> 删除
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
				<div class="new-address--pad"  ></div>
				
				
		</div>
		
		<div class='editPage' v-if='add'>
			<div class='tips'>温馨提示：为确保海关顺利清关，收货人姓名请与身份证信息保持一致</div>
			
			    <div class="formbox">
			        <div class="field">
			            <div class="name">收货人：</div>
			            <div class="value">
							<input type="text" placeholder="跨境清关，请填写真实姓名"  v-model="name" maxlength='10'/>
						</div>
			        </div>
			        <div class="field">
			            <div class="name">身份证号：</div>
			            <div class="value">
							<input type="idcard" placeholder="请填写身份证号" maxlength='18' v-model="idCard" />
						</div>
			        </div>
			        <div class="field">
			            <div class="name">联系方式：</div>
			            <div class="value"><input type="number" placeholder="请填写电话号码" maxlength='11'  v-model="phone" placeholder-class='placeholderclass'/></div>
			        </div>
			
			        <div class="field border-none ">
			            <div class="name">所在地区：</div>
			            <div style='display: flex;'>
							<div class='input95' @click='choseShen'>
							      <div class='cityslect'>{{shen}}</div>
							      <div class="cityBox" v-show='showShen'>
							          <div v-for='item in shenCity' :data-city='item' @click='choseShenItem'>{{item}}</div>
							      </div>
							</div>
							<div class='input95' @click='choseShi'>
							      <div class='cityslect'>{{shi}}</div>
							      <div class="cityBox" v-show='showShi'>
							          <div v-for='item in shiCity' :data-city='item' @click='choseShiItem'>{{item}}</div>
							      </div>
							</div>
							<div class='input95' @click='choseQu'>
							      <div class='cityslect'>{{qu}}</div>
							      <div class="cityBox" v-show='showQu'>
							          <div v-for='item in quCity' :data-city='item' @click='choseQuItem'>{{item}}</div>
							      </div>
							</div>
			                
			            </div>
			        </div>
			        
			        <div class="field cloumn border-none">
			            <div class="name" style="margin-bottom: 0.2rem;">详细地址：</div>
			            <div class="value">
			                <div class="textarea">
			                    <textarea placeholder="请输入你的详细地址" v-model="addressDetail" style='width:100%;height: 2.2rem;' ></textarea>
			                </div>
			            </div>
			        </div>
			        
			    </div>
			
			    <div class="btns"> 
			        <div class="app-btn app-btn--shadow"  @click='checkAddressInfo' style='margin-bottom: 0.5rem;'>保存</div>
					<div class="app-btn app-btn--white app-btn--shadow"  @click='handleEditPage' >取消</div>
			    </div>
		
			
		</div>
		
	</div>	
  </div>
</template>

<script>
import eventBus from '../popup/eventBus.js'
const allcity = require('@/components/cityId.js').cityId;

export default {
  name: 'myAddress',
  components: {

  },
  data(){
		return {
			edit:false,
			add:false,
			addressList:[],
			name:"",
			idCard:"",
			phone:"",
			addressDetail:"",
			shen:'省',
			shi:'市',
			qu:'县/区',
			orderMsg:"",
			addressid:"",
			shenCity:[],
			shiCity:[],
			quCity:[],
			showShen:false,
			showShi:false,
			showQu:false,
			saveMark:false,      		//连续点击拦截
			orderMadeFrom:false,        //创建订单选择地址来
			delAddressShow:false,
			delid:"",
		}
    },
    computed: {
     
    },
	beforeCreate:function() {
		console.log(this.$route)
	 
	  if(this.$route.params.ordermade){
	    this.orderMadeFrom = true
	  }
	},
    mounted() {
		this.getAddressList()
    },
    created:function(){
   	
  	},
    methods:{
		hanleChooseAddress(event) {
			console.log("地址页")
		　　this.$emit('changeFN', event);
		
			
		},
		// 获取已有地址列表
		getAddressList(){
			let that = this
			this.axios({
			            method: 'post',
			            url:"Address/getAddressList",
			            data:{
			               member_id:this.$store.state.member_id,
			            }
			    }).then(res=>{
					 this.addressList = res.data.addressList
				})
		},
		handleAddAddress(){
			this.add = true
			let _shenCity = allcity.data
			let shenCity = []
			_shenCity.forEach((item)=>{
			  shenCity.push(item.name)
			})
			this.addressid = ""
			this.name=""
			this.idCard=""
			this.phone=""
			this.addressDetail=""
			this.shen='省'
			this.shi='市'
			this.qu='县/区'
			this.orderMsg=""
			this.addressid=""
			this.shenCity=shenCity
			this.shiCity=[]
			this.quCity=[]
		},
		// 打开添加新地址页面
		handleEditPage(){
			this.add = !this.add
		},
		// 管理地址
		toggle(){
			this.edit = !this.edit
		},
		handleEdit(eve){
			this.handleEditPage()
			this.getAddress(eve)
			console.log(eve)
		},
		// 获取已有地址
		 getAddress(eve){
		    let that = this
		   
				this.addressid = eve.id
				this.name=eve.name
				this.addressDetail=eve.address
				this.idCard=eve.id_card
				this.phone=eve.phone
				this.addressDetail=eve.address
				this.shen=eve.province_name
				this.shi=eve.city_name
				this.qu=eve.area_name
	
		  },
		// 设置默认地址
		switchAddress(){
			
		},
	// 删除地址
	handleDel:function(e){
		this.delAddressShow=true
		this.delid = e
	},
	closeDel:function(){
		this.delAddressShow=false
		this.delid = ""
	},
	delAddress:function(){
	let that = this
	if(!this.delid){
		this.delAddressShow=false
		return
	}
	console.log(that.addressList)
	this.axios({
	            method: 'post',
	            url:"Address/delAddress",
	            data:{
	               member_id:this.$store.state.member_id,
				   id: this.delid
	            }
	    }).then(res=>{
			let _addressList = that.addressList
			_addressList.forEach((item, index, array) => {
					if (item.id == that.delid) {
					  array.splice(index, 1)
					}
			})
		
			that.addressList=_addressList
			that.delAddressShow=false
		})
	

	},
		choseShen(){
			this.showShen = !this.showShen
			
			this.showShi= false
			this.showQu=false
		},
		choseShenItem(e){
			if(e.target.dataset.city != this.shen){
				  this.shen = e.target.dataset.city
				  this.shi='市'
				  this.qu='县/区'
			}
		  
		},
		choseShi(){
		  if(this.shen=="省"){
		    alert("请先选择省")
		    return
		  }
		  this.showShi = !this.showShi
		  this.showShen = false
		  this.showQu=false
		  let _shenCity = allcity.data
		  let _shiCity = []
		  let _shiList =[]
		  _shenCity.forEach((item)=>{
		    if( item.name == this.shen){
		        _shiList = item.sonList
		      }
		  })
		  _shiList.forEach((item)=>{
		        _shiCity.push(item.name)
		  })
		  this.shiCity = _shiCity
		},
		choseShiItem(e){
		  if(e.target.dataset.city != this.shi){
		      this.shi = e.target.dataset.city
		      this.qu='县/区'
		  }
		},
		choseQu(){
		  if(this.shi=="市"){
		    alert("请先选择市")
		    return
		  }
		  this.showQu = !this.showQu
		  this.showShen = false
		  this.showShi= false
		  let _shenCity = allcity.data
		  let _quCity = []
		  let _shiList =[]
		  let _quList = []
		  _shenCity.forEach((item)=>{
		    if( item.name == this.shen){
		      _shiList = item.sonList
		      }
		  })
		  _shiList.forEach((item)=>{
		    if( item.name == this.shi){
		      _quList = item.sonList
		      }
		  })
		  _quList.forEach((item)=>{
		    _quCity.push(item.name)
		  })
		  this.quCity = _quCity
		},
		 choseQuItem(e){
		  if(e.target.dataset.city != this.qu){
		      this.qu = e.target.dataset.city
		  }
		},
		// 检查地址信息是否填写完整
		checkAddressInfo(){
			if(this.name.length<1){
			  alert("请填写姓名")
			  return
			}
			if(this.idCard.length<18){
			  alert("请填写正确的身份证号码")
			  return
			}
			if(this.phone.length!=11){
			  alert("请填写正确的手机号码")
			  return
			}
			if(this.shen=="省"){
			  alert("请选择省份")
			  return
			}
			if(this.shi=="市"){
			  alert("请选择市/区")
			  return
			}
			
			if(this.addressDetail.length<1){
			  alert("请填写地址已保证您能收到橘袋")
			  return
			}
			if (this.idCard){
			      let _age = this.idCard.substring(6, 10)
			      _age = 2019 - _age
			      if (_age < 16 || _age > 85) {
					  alert("海关验证失败，身份证异常（年龄必须在16-85之间）")
			        return
			      }
			}  
			this.saveAddress()
		},
		// 保存地址
	    saveAddress(){
			let that = this
			    if (this.saveMark){
			      setTimeout(()=>{
			        this.saveMark = false
			      },1000)  
			      return
			    }
			    this.saveMark = true
			    
			let _region = [this.shen,this.shi,this.qu]
			let _data = {
				member_id:this.$store.state.member_id,
				name: this.name,
				phone:this.phone,
				id_card:	this.idCard,
				region:_region,
				address:	this.addressDetail,
				is_default:0,
			}
			if(this.addressid){
				_data.id = this.addressid
			}
			this.axios({
			            method: 'post',
			            url:"Address/saveAddress",
			            data:_data
			    }).then(res=>{
					 if (res.data.code==1){
					 
					          
					           if (that.orderMadeFrom) {
					             that.$router.go(-1)
					           }else{
					             that.add=false
								 that.getAddressList()
					           }
					         } else if (res.data.code == 0){
									alert(res.data.msg)
									that.saveMark=false
					         
					       }
				})
		},


  }
}
</script>
<style>
#addressPage{
  background:rgba(244,242,240,1);
  width: 7.5rem;
  height: 100vh;
  box-sizing: border-box;
  position:absolute;
  z-index: 91;
  top: 0;
  left: 0;
  left: 50%;
  overflow-y:auto;
  transform: translate(-50%,0);
}
.addressPageBox{
	
}
#addressPage::-webkit-scrollbar {display:none}
.editPage{
	background: #fff;
	width: 7.5rem;
	height: 100vh;
}
.option-btn {
    padding: 0.2rem;
    text-align: right;
    background: #fff;
    border-bottom: 2px solid #eee;
}
#addressPage .addressitem {
	display: block;
    margin-bottom: 0.15rem;
    background: #fff;
	text-align: left;
}
.addressitem .default {
    border-bottom: 2px dashed rgba(26, 27, 46, 1);
}
.addressitem .name-phone {
    display: flex;
    justify-content: space-between;
    padding: 0.3rem 0.2rem 0 0.2rem;
}
.addressitem .street {
    font-size: 0.28rem;
    padding: 0.2rem;
	
}
.addressitem .street span {
    color: #C25E4D;
    margin-right:0.1rem;
}
.addressitem .options {
    border-top: 1px solid #eee;
    padding: 0.2rem;
    display: none;
    justify-content: space-between;
    align-items: center;
    color: #666666;
    font-size: 0.28rem;
}
.addressitem .options>div {
    display: flex;
    align-items: center;
}
.addressitem .options .left img {
    width: 0.35rem;
    height: 0.35rem;
    margin-right:0.1rem;
}
.addressitem .options .right img {
    margin-right:0.1rem;
}
.addressitem .options .right .btn {
    display: flex;
    align-items: center;
    margin-left:0 0.3rem;
}

.new-address--pad {
    height: 1.8rem;
}
#newaddress{
    position:fixed !important;
	z-index: 99;
    left: 50%;
	transform: translate(-50%,0); 
	width: 7.5rem;
	height: 2rem;
    bottom: 0;
    padding:0.5rem 0.3rem;
	box-sizing: border-box;
    background: #fff;
    box-shadow: 0px -6px 20px 0px rgba(0,0,0,0.08);
    text-align: center;
}

.addresses.is-edit .options {
    display: flex;
}
.addresses.is-edit .addressitem .street span {
    display: none;
}
.addresses.is-edit .addressitem .default {
    border: none;
}
.idcard{
  padding: 0 0.2rem;
}


/* pages/home/address/edit.wxss */



.field {
    display: flex;
    align-items: center;
    padding: 0.24rem 0.4rem;
    position: relative;
}
.field:after {
    position: absolute;
    content: "";
    left: 0.4rem;
    right: 0;
    bottom: 0;
    height: 1px;
}
.field.border-none:after {
    height: 0;
}
.field.cloumn {
    flex-direction: column;
    align-items: flex-start;
}
.field .name {
    width: 1.6rem;
    flex-shrink: 0;
	text-align: left;
}
.field .value  {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-grow: 2;
}

.field.cloumn .value {
    width: 100%;
    
}
.field .value input{
   font-size: 0.28rem;
    
}
.picker{
  position: relative;
  width: 5.1rem;
}
.pickerImg{
   position: absolute;
   width: 0.16rem;
   height: 0.29rem;
   right: 0.2rem;
   top:5rpx;
}
.pickTxt{
   height:100%;
   width: 5.1rem;
   color: #666666;
}
.field .value input{
	width: 100%;
	font-size: 0.22rem;
}
.field .value span {
    color: #666666;
}
.field .value .icon-link {
    width: 0.16rem;
    height: 0.29rem;
}
.field .value .textarea {
    
    width: 100%;
}
.field .value .textarea textarea {
    width: 7.5rem;
	resize: none;
    height: 2.22rem;
	border: none;
	margin:0;
	padding: 0.25rem;
	border: 1px dashed #979797;
	border-radius: 0.05rem;
}

.default {
    padding: 0.2rem 0.3rem;
}
.default .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.default  .remark {
    color: #999;
    font-size: 0.28rem;
}

.btns {
    text-align: center;
    margin: 0.5rem 0;
}
.btns .app-btn {
    width: 60%;
}
.placeholderclass{
  font-size: 0.24rem;
  color: #999999;
}
.tips{
   text-align: left;
  background-color: #595959;
  color: #E0E0E0;
  font-size: 0.24rem;
  padding:0.1rem 0.4rem;
}
.cityBox{
    width:1.5rem;
    height:3rem;
    background:rgba(255,255,255,1);
    border-radius:0.05rem;
    border:1px solid rgba(229,229,229,1);
    text-align:center;
    position: absolute;
    top:0.3rem;
    left: 0;
    box-sizing: border-box;
    overflow-y: auto;
	z-index: 10;
}
.cityslect{
  overflow: hidden;
}
.inputBtnBox{
  display: flex;
  justify-content: space-between;
}
.input95{
  width:1.5rem;
  height:30px;
  line-height: 30px;
  background:rgba(255,255,255,1);
  border-radius:5px;
  border:1px solid rgba(229,229,229,1);
  padding: 0 10px;
  margin-right: 10px;
  display: flex;
  justify-content: space-between;
  position: relative;
}

.delAddressBox{
	  width: 5.5rem;
	  position: fixed;
	  left: 50%;
	  top:50%;
	  transform: translate(-50%, -50%);  
	  background-color: #fff;
	  border-radius: 0.2rem;
	  z-index: 100;
	}
	.delAddressBoxTitle{
	  text-align: center;
	  font-size: 0.32rem;
	  line-height: 0.6rem;
	  padding: 0.5rem;
	}
	
	
	.delAddressBoxBtn{
	  display: flex;
	  padding: 0.2rem 0;
	  border-top: 0.01rem solid #BBBBBB;
	}
	.delAddressBoxBtn div{
	  width: 6rem;
	  text-align: center;
	  height:0.48rem;
	  font-size: 0.28rem;
	  letter-spacing: 0.1rem;
	  line-height: 0.48rem;
	  border-right: 1px solid #BBBBBB;
	  font-family:PingFangSC-Medium,PingFang SC;
	  font-weight:400;
	  color: #666666;
	}
	.delAddressBoxBtn div:last-child{
	  border-right: none;
	}
	.delAddressPop{
		width: 7.5rem;
		height: 100vh;
		background: rgba(0, 0, 0, 0.5);
		position: fixed;
		left: 50%;
		top:0;
		transform: translate(-50%, 0);  
		z-index: 99;
	}
</style>